module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00073.9de9e88b.jpg";